import { AppBar, Box, Toolbar, Typography, Button } from "@mui/material";

import { useNavigate } from "react-router-dom";

import { useAppSelector, useAppDispatch } from "../redux/hooks";
import { logout } from "../redux/app.slice";
import { getApp } from "../redux/app.slice";

export const NavigationComponent = () => {
  const navigate = useNavigate();

  const app = useAppSelector(getApp);
  const dispatch = useAppDispatch();

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static">
        <Toolbar variant="dense">
          <Typography variant="subtitle1" component="div" sx={{ flexGrow: 1 }}>
            LSC Group Portal (v3.2)
          </Typography>
          {app.isLoggedIn ? (
            <>
              <Button color="inherit" onClick={() => navigate("/dashboard")}>
                Home
              </Button>
              <Button
                color="inherit"
                onClick={() => {
                  dispatch(logout());
                  navigate("/");
                }}
              >
                Logout
              </Button>
            </>
          ) : (
            <>
              <Button color="inherit" onClick={() => navigate("/")}>
                Login
              </Button>
              <Button color="inherit" onClick={() => navigate("/register")}>
                Register
              </Button>
            </>
          )}
        </Toolbar>
      </AppBar>
    </Box>
  );
};
